import React, { Component } from 'react'

const FAQS = [
  {
    q: "Sur quelles sources de données Fetchy s'appuie-t-il ?",
    a: "Les cibles nutritionnelles de Fetchy sont fondées sur FEDIAF, AAFCO & la littérature scientifique — jamais une norme seule. Chaque valeur croise les standards officiels, les publications à comité de lecture et l'avis d'experts, et reste traçable jusqu'à sa source.",
  },
  {
    q: "Peut-on mélanger ménager et industriel dans une même ration ?",
    a: "Oui. La recette mixte combine ingrédients ménagers et aliments industriels dans une seule ration équilibrée. Que la réponse clinique soit ménager, industriel ou mixte, Fetchy mesure l'ensemble contre les mêmes cibles.",
  },
  {
    q: "Sur quels appareils Fetchy fonctionne-t-il ?",
    a: "Fetchy est conçu pour ordinateur et tablette, là où se fait le travail clinique. L'écran de consultation, le clavier et la précision des chiffres comptent — ce n'est pas un outil qu'on remplit d'une main entre deux portes.",
  },
  {
    q: "Comment fonctionne l'accès étudiant ?",
    a: "Envoie ton certificat de scolarité via le formulaire ci-dessus. On vérifie manuellement et tu reçois tes identifiants sous 48h. L'accès est gratuit jusqu'à ta date de fin d'études.",
  },
  {
    q: "Comment fonctionne la facturation de groupe ?",
    a: "Les cliniques sont facturées par structure ; les écoles, groupes et partenaires CPD bénéficient d'une facturation groupée sur devis. Un seul interlocuteur, une seule facture, autant de comptes que de praticiens.",
  },
  {
    q: "Puis-je résilier à tout moment ?",
    a: "Oui. L'abonnement est sans engagement et résiliable à tout moment depuis ton espace. Tes prescriptions déjà émises restent accessibles dans l'historique de tes patients.",
  },
  {
    q: "Je ne suis pas à l'aise avec le rationnement, par où commencer ?",
    a: "Fetchy guide chaque étape et l'AutoPilot fait les calculs à ta place. Pour te former en profondeur, les formations CVE d'Arginine sont conçues par notre co-fondatrice — et les stagiaires Arginine bénéficient d'un accès Fetchy offert.",
  },
]

class Faq extends Component {
  constructor(props) {
    super(props);
    this.state = { open: 0 };
  }

  toggle = (i) => {
    this.setState({ open: this.state.open === i ? -1 : i });
  }

  render() {
    const { open } = this.state;

    return (
      <section className="vt-section" id="faq">
        <div className="vt-shell">
          <div className="tc" style={{ maxWidth: 640, margin: '0 auto 48px' }}>
            <span className="eyebrow">FAQ</span>
            <h2>Tout ce qu'on nous demande.</h2>
          </div>

          <div className="faq-wrap">
            {FAQS.map((f, i) => (
              <div className={`faqitem${open === i ? ' open' : ''}`} key={i}>
                <button className="faqitem__q" onClick={() => this.toggle(i)}>
                  <span>{f.q}</span>
                  <span className="faqitem__icon">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  </span>
                </button>
                <div className="faqitem__a">
                  <div className="faqitem__inner">{f.a}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    )
  }
}

export default Faq
